module.exports = globalThis.mcData["blockCollisionShapesArray"] ?? globalThis.mcData["blockCollisionShapes"]